/* eslint-disable require-jsdoc */
import React, { useEffect, useState } from 'react';
import Searchbox from './Searchbox';
import Locations from './Locations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Filters from './Filters/Filters';
import { debug, geoApiKey } from '../config';
import http from '../services/http';
import { A4map } from '../hearbymap/src/A4map/A4map';
import { isValid } from '../utils/validate';
export default function Searchbar(props) {
  const [lat, setLat] = useState(props.settings.defaultLocation.lat);
  const [lon, setLon] = useState(props.settings.defaultLocation.lon);
  const [minDate, setMinDate] = useState('2021-03-13');
  const [maxDate, setMaxDate] = useState('2021-09-13');
  const [searchVal, setSearchVal] = useState('');
  const [geolocation, setGeolocation] = useState(props.settings.defaultLocationName);
  const [loadingGeolocation, setLoadingGeolocation] = useState(true);
  const [locPopoverOpen, setLocPopoverOpen] = useState(false);
  const [calendarPopover, setCalendarPopOver] = useState(false);
  const [genrePopoverOpen, setGenrePopoverOpen] = useState(false);
  const [resetSharedEventUrl, setResetSharedEventUrl] = useState(false);

  // flag listen
  useEffect(() => {
    debug && console.log('loc changed!');
  }, [lat, lon]);

  const [submit, setSubmit] = useState(false);
  const [searchSubmit, setSearchSubmit] = useState(false);

  // event search
  const [evtsubmit, setEvtSubmit] = useState(false);
  const [eventsubmit, setEventSubmit] = useState(false);
  const [eventsearchsubmit, setEventSearchSubmit] = useState(false);

  const [searchEraseAndSubmit, setSearchEraseAndSubmit] = useState(false);

  const handleClick = () => {
    setSubmit(true);
    //window.aMap.changeLocation(lat, lon);
    
    // if (!locChanged(this.loc.lat, this.loc.lng, lat, lng)) {
    //   //A4map.get.setMapMarkers();
    // }

    window.changePowersearchLoc(lat, lon);
    setTimeout(
      function () {
        setSubmit(false)
      },
      3000);
  }
  const options = {
    enableHighAccuracy: true,
    timeout: 300,
    maximumAge: 0
  };


  let eraseShareLinkData = false;
  window.eraseShareLinkData=function (shareLinkData) {
    eraseShareLinkData = isValid(shareLinkData) ? shareLinkData : false;
    setResetSharedEventUrl(true);
  };  


  useEffect(() => {
    if (window.powersearchUserSettings.geolocation) {
      if (navigator.geolocation) {
        debug && console.log('Searchbar.jsx Object.values(props.sharedEventParams)[0]: ',Object.values(props.sharedEventParams)[0]);
        if (Object.values(props.sharedEventParams)[0]===null) {
          navigator.geolocation.getCurrentPosition(
            function (position) {
              const geocodeEarth = geoApiKey;
              const query = `https://api.geocode.earth/v1/reverse?api_key=${geocodeEarth}&point.lat=${position.coords.latitude}&point.lon=${position.coords.longitude}`;
              getResults(query);
            },
  
            function (error) {
              debug && console.log('geolocation error', error);
            });
          // setLoadingGeolocation(false);
        } 
        else {
          const geocodeEarth = geoApiKey;
          const query = `https://api.geocode.earth/v1/reverse?api_key=${geocodeEarth}&point.lat=${Object.values(props.sharedEventParams)[1]}&point.lon=${Object.values(props.sharedEventParams)[2]}`;
          debug && console.log('Searchbar.jsx else loop query: ', query);
          getResults(query);
        }         
      }

      // getResults(query);
    }
  }, [props.sharedEventParams, resetSharedEventUrl]);

  const sanitize = (data) => {
    return (data !== '' && data !== undefined) ? (data + ', ') : '';
  }
  const sanitizeCountry = (data) => {
    return (data !== '' && data !== undefined) ? (data) : '';
  }

  const getResults = async (queryStr) => {
    try {
      const response = await http.get(queryStr, false);
      debug && console.log('results fetched ', response);
      setGeolocation(sanitize(response['features'][0]['properties']['locality']) +
        sanitize(response['features'][0]['properties']['region_a']) +
        sanitizeCountry(response['features'][0]['properties']['country_a']));
      debug && console.log(loadingGeolocation);
      const newLat = response['features'][0]['geometry']['coordinates'][1];
      const newLon = response['features'][0]['geometry']['coordinates'][0];
      setLat(newLat);
      setLon(newLon);
      // debug && console.log("set new loc");
      // window.aMap.changeLocation(newLat, newLon);
      // //window.aMap.init();
      // // window.aMap.loc.lat = lat;
      // // window.aMap.loc.lng = lon;
      // debug && console.log('coords', newLat, newLon);
  
      !isValid(props.sharedEventParams) && window.changePowersearchLoc(newLat, newLon);

      A4map.get.changeLocation(newLat, newLon);
      //successMapChange({lat: lat, lon: lon}, window.aMapRef);
      //  setLoadingGeolocation(false);
    } catch (err) {
      // setLoadingGeolocation(true);
      console.error(err.message);
    }
  };
  
  return (
    <div className="hearby-searchbar">
      <Searchbox searchVal={searchVal} setEventSearchSubmit={setEventSearchSubmit} 
        setSearchVal={setSearchVal} setEventSubmit={setEventSubmit}/>
      <Locations minDate={minDate} maxDate={maxDate} lat={lat} setLat={setLat} 
        setLon={setLon} lon={lon} geolocation={geolocation} setGeolocation={setGeolocation} 
        locPopoverOpen={locPopoverOpen} setLocPopoverOpen={setLocPopoverOpen} setCalendarPopOver={setCalendarPopOver} setGenrePopoverOpen={setGenrePopoverOpen} />
      <Filters searchVal={searchVal} eventsearchsubmit={eventsearchsubmit} eventsubmit={eventsubmit} setEventSubmit={setEventSubmit} submit={submit} setSubmit={setSubmit} setEventSearchSubmit={setEventSearchSubmit} lat={lat} lon={lon}
        calendarPopover={calendarPopover} genrePopoverOpen={genrePopoverOpen} setCalendarPopOver={setCalendarPopOver} setGenrePopoverOpen={setGenrePopoverOpen}
        setLocPopoverOpen={setLocPopoverOpen} defaultTimeFrame={props.settings.defaultTimeframeForSearch} psBarSettings={props.settings.powersearchBarOpts}
        searchEraseAndSubmit={searchEraseAndSubmit}
      />    
      <div className="hearby-powersearch-area hearby-submit-search" onClick={handleClick}><button className="hearby-submit-button"><FontAwesomeIcon className="hearby-submit-button-icon" icon={faSearch}/></button></div>
      </div>
  );
};